const PHASES = [
    {
        num: "01",
        title: "Fondations",
        subtitle: "L'ancrage · la précision",
        text: "Terrassement, ferraillage et coulage de la dalle : la base d'un édifice qui traversera les générations. Chaque millimètre est contrôlé.",
        image:
            "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/v6gjxfcn_Screenshot_20260811_180927_WhatsAppBusiness.webp",
    },
    {
        num: "02",
        title: "Élévation",
        subtitle: "Maçonnerie · isolation intégrée",
        text: "Montage des murs en briques monomur nouvelle génération, avec isolation intégrée dès la structure. Le geste artisanal, rehaussé par les matériaux d'aujourd'hui.",
        image:
            "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/q2nv6tq9_Screenshot_20260811_175708_Photos.webp",
    },
    {
        num: "03",
        title: "Structure porteuse",
        subtitle: "Murs & ouvertures",
        text: "Les murs se dressent, les baies dessinent la lumière future. Étaiement et cordeaux garantissent la géométrie parfaite de l'ouvrage.",
        image:
            "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/v6gc9mht_Screenshot_20260811_175623_Photos.webp",
    },
    {
        num: "04",
        title: "Charpente",
        subtitle: "Traditionnelle · assemblée main",
        text: "Fermes, arbalétriers et pannes en épicéa massif. Chaque assemblage est vérifié à la clé dynamométrique. L'ossature qui tiendra un siècle.",
        image:
            "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/mokluvuz_20260320_161016.webp",
    },
    {
        num: "05",
        title: "Couverture",
        subtitle: "Tuiles nobles · faîtage orné",
        text: "Pose des tuiles plates de terre cuite, arêtiers façonnés et poinçon central. La signature d'un toit à la française, dressé sur la campagne.",
        image:
            "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/qpklzg71_Screenshot_20260811_171344_WhatsAppBusiness.webp",
    },
];

export default function Journey() {
    return (
        <section
            id="realisations"
            data-testid="journey"
            className="py-32 bg-[#FAF9F6] relative overflow-hidden"
        >
            {/* Ambient decorative typography */}
            <div
                aria-hidden
                className="pointer-events-none absolute top-24 -right-10 md:right-12 font-serif-lux text-[#B89C6A]/[0.06] text-[28vw] leading-none select-none"
            >
                05
            </div>

            <div className="max-w-[1500px] mx-auto px-6 md:px-12 relative">
                {/* Section header */}
                <div className="max-w-3xl mb-24 section-fade">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">
                            Étapes du chantier · Réalisation
                        </span>
                    </div>
                    <h2 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                        De la <em className="italic text-[#B89C6A]">
                            fondation
                        </em>
                        <br /> au <em className="italic">faîtage</em>.
                    </h2>
                    <p className="mt-6 text-[15px] leading-relaxed text-[#1C1E1D]/70">
                        Chaque construction CM RENOV traverse cinq grandes étapes.
                        Une chronologie maîtrisée, où le savoir-faire d'hier rencontre les
                        exigences d'aujourd'hui.
                    </p>
                </div>

                {/* Phases */}
                <div className="relative">
                    {/* Vertical golden line */}
                    <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#B89C6A]/30 to-transparent -translate-x-1/2" />

                    {PHASES.map((p, i) => {
                        const reverse = i % 2 === 1;
                        return (
                            <article
                                key={p.num}
                                data-testid={`phase-${p.num}`}
                                className={`relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center mb-24 lg:mb-32 section-fade ${
                                    reverse ? "lg:[direction:rtl]" : ""
                                }`}
                            >
                                {/* Image */}
                                <div
                                    className="lg:col-span-7 relative group [direction:ltr]"
                                >
                                    <div className="aspect-[4/3] overflow-hidden bg-[#0e0f0e]">
                                        <img
                                            src={p.image}
                                            alt={`Étape ${p.num} · ${p.title}`}
                                            loading="lazy"
                                            className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.04]"
                                        />
                                    </div>

                                    {/* Number badge overlapping image */}
                                    <div
                                        className={`absolute -top-8 ${
                                            reverse ? "-right-4 md:-right-8" : "-left-4 md:-left-8"
                                        } bg-[#FAF9F6] border border-[#B89C6A]/40 px-6 py-3 shadow-lg`}
                                    >
                                        <span className="tracking-luxe text-[#B89C6A] text-[10px]">
                                            Étape
                                        </span>
                                        <div className="font-serif-lux text-4xl leading-none mt-1">
                                            {p.num}
                                            <span className="text-[#B89C6A]/50 text-lg ml-1">
                                                /05
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Copy */}
                                <div className="lg:col-span-5 [direction:ltr]">
                                    <div className="tracking-luxe text-[#B89C6A] mb-4">
                                        {p.subtitle}
                                    </div>
                                    <h3 className="font-serif-lux text-3xl md:text-4xl lg:text-5xl leading-[1.05]">
                                        {p.title}
                                    </h3>
                                    <p className="mt-6 text-[14px] leading-relaxed text-[#1C1E1D]/75 max-w-md">
                                        {p.text}
                                    </p>
                                    <div className="mt-8 flex items-center gap-4">
                                        <span className="h-px w-12 bg-[#B89C6A]" />
                                        <span className="tracking-luxe text-[#1C1E1D]/50 text-[10px]">
                                            Île-de-France · CM RENOV
                                        </span>
                                    </div>
                                </div>

                                {/* Dot on the line */}
                                <div className="hidden lg:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-[#B89C6A] ring-4 ring-[#FAF9F6]" />
                            </article>
                        );
                    })}
                </div>

                {/* Closing CTA */}
                <div className="text-center mt-8 section-fade">
                    <div className="tracking-luxe text-[#B89C6A] mb-4">
                        Votre projet, notre chronologie
                    </div>
                    <h3 className="font-serif-lux text-3xl md:text-4xl max-w-2xl mx-auto leading-tight">
                        Estimez votre construction ou rénovation en quelques clics.
                    </h3>
                    <a
                        href="#devis"
                        data-testid="journey-cta"
                        className="btn-champagne mt-10 inline-flex"
                    >
                        Ouvrir l'estimateur
                        <span aria-hidden>→</span>
                    </a>
                </div>
            </div>
        </section>
    );
}
